import React from "react";

export const Footer = () => {
  return (
    <div className="max-w-[1200px] sm:h-[150px] p-12 flex justify-between mx-auto">
      <span className="primary-color">Ahmad Fauzan</span>
      <p className="text-gray-600">
        ahmadfauzan.280.af@gmail.com <br />
        #WebDev2025
      </p>
    </div>
  );
};
